export default __webpack_public_path__ + "static/media/Tuplecube.bd604dda.jpg";